import { Button, Grid2, Stack, Typography } from "@mui/material";
import ContainerLoading from "../components/ContainerLoading";
import { IconClipboard } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import ClassRegister from "../components/ClassRegister";
import { classList } from "../services/class";
import ClassTableComponent from "../components/ClassTableComponent";
import PageHeader from "../components/PageHeader";

const Class = () => {
  const [open, setOpen] = useState(false);

  const {
    data,
    isLoading,
    isFetching,
    refetch,
  }: {
    data: Array<{
      id: string;
      date?: Date;
      startTime?: Date;
      endTime?: Date;
      name: string;
      description?: string;
      fightsId: string;
      spacesId: string;
      dayWeek: string;
      automaticCompletion: boolean;
      checkinLock: boolean;
      professorId?: Array<string>;
      createdAt?: Date;
      status?: boolean;
      professors?: Array<{
        professorId: string;
        fullName: string;
      }>;
    }>;
    isLoading: boolean;
    isFetching: boolean;
    refetch: () => void;
  } = useQuery({
    queryKey: ["classList"],
    queryFn: async () => await classList({}),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Turmas"
          subtitle="Informações gerais das turmas."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconClipboard size={18} />
                <Typography variant="body2">Criar turma</Typography>
              </Button>
            </Stack>
          }
        />

        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <ClassTableComponent data={data} refetch={() => refetchAll()} />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <ClassRegister
        open={open}
        onClose={() => setOpen(false)}
        refetch={() => refetchAll()}
      />
    </ContainerLoading>
  );
};

export default Class;
